import React from 'react';
import PropTypes from 'prop-types';
import { withTag } from './styled';

class Heading extends React.PureComponent {
  static defaultProps = {
    level: 1
  };

  static propTypes = {
    level: PropTypes.oneOf(
      [
        1, '1', 'h1',
        2, '2', 'h2',
        3, '3', 'h3',
        4, '4', 'h4',
        5, '5', 'h5',
        6, '6', 'h6',
      ]
    )
  };

  render() {
    const {
      level,
      className,
      children,
    } = this.props;

    let validLevel;
    if (typeof(level) === 'number') {
      validLevel = parseInt(level, 10);

    } else if (typeof(level) === 'string') {
      const [firstChar, ...rest] = level;
      if (firstChar === 'h') {
        validLevel = rest;
      } else {
        validLevel = parseInt(level, 10);
      }
    }

    if (validLevel) {
      const StyledHeading = withTag(`h${validLevel}`);
      return (
        <StyledHeading level={validLevel} className={className}>
          {children}
        </StyledHeading>
      );
    }
    return null;
  }
};

export default Heading;



// WEBPACK FOOTER //
// ./src/elements/Heading/Heading.jsx